function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useOverlayContext } from 'seagull';
import { ClientPreview } from "../components/ClientPreview/ClientPreview";
import { useStore, useStoreActions, useStoreStatic } from "../contexts";
import { handleRequest } from "../infra/utils";
import { selectors } from "../store/state-selectors";
import { jsx as _jsx } from "react/jsx-runtime";
export const usePreviewDraft = _ref => {
  let {
    sampleContact,
    contactsMap
  } = _ref;
  const {
    api,
    fetchLegalTerms
  } = useStoreActions();
  const {
    getState
  } = useStoreStatic();
  const overlayContext = useOverlayContext();
  const worksAt = useStore(selectors.user.business);
  const previewDraft = async draftId => {
    let legalTermsDocuments = getState().legalTerms.data || [];
    if (!legalTermsDocuments) {
      legalTermsDocuments = (await fetchLegalTerms()) || [];
    }
    if (!legalTermsDocuments || !worksAt) return;
    const result = await handleRequest(api.draft.getById(draftId));
    if (!result.success) {
      overlayContext.showErrorToast(result.error, 'preview-draft-error');
      return;
    }
    const dto = result.data.toDTO();
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: props => /*#__PURE__*/_jsx(ClientPreview, _objectSpread({
        type: "draft",
        draftInfo: {
          draft: dto,
          sampleContact,
          contactsMap,
          legalTerms: legalTermsDocuments
        }
      }, props))
    });
  };
  return {
    previewDraft
  };
};